console.log( 'Hello @wordpress/scripts!!!' );
